import React from "react";

import "./AccountInformation.css";

import {
    User,
    Mail,
    Phone,
    Calendar,
    ShieldCheck
} from "lucide-react";


const AccountInformation = ({
    data
}) => {


    /* =====================================================
       GET USER

       Name / Email எங்கிருந்து எடுக்கிறோமோ
       அதே USER object-லிருந்து service-ம் எடுக்கப்படும்.
    ===================================================== */

    const user =
        data?.user ||
        data?.profile ||
        data ||
        {};


    /* =====================================================
       SERVICE

       Priority:

       1. user.metadata.service
       2. user.service
       3. data.metadata.service
       4. data.service
       5. -
    ===================================================== */

    const service =
        user?.metadata?.service ||
        user?.service ||
        data?.metadata?.service ||
        data?.service ||
        "-";


    return (

        <div className="account-information">


            {/* =================================================
                HEADER
            ================================================= */}

            <div className="account-header">

                <h2>

                    Account Information

                </h2>


                <p>

                    Your registered account details.

                </p>

            </div>


            {/* =================================================
                ACCOUNT GRID
            ================================================= */}

            <div className="account-grid">


                {/* =================================================
                    FULL NAME
                ================================================= */}

                <div className="account-item">

                    <User size={22} />

                    <div>

                        <span>

                            Full Name

                        </span>


                        <h4>

                            {
                                user?.name ||
                                "-"
                            }

                        </h4>

                    </div>

                </div>


                {/* =================================================
                    EMAIL
                ================================================= */}

                <div className="account-item">

                    <Mail size={22} />

                    <div>

                        <span>

                            Email Address

                        </span>


                        <h4>

                            {
                                user?.email ||
                                "-"
                            }

                        </h4>

                    </div>

                </div>


                {/* =================================================
                    PHONE
                ================================================= */}

                <div className="account-item">

                    <Phone size={22} />

                    <div>

                        <span>

                            Phone Number

                        </span>


                        <h4>

                            {
                                user?.phone ||
                                "Not Available"
                            }

                        </h4>

                    </div>

                </div>


                {/* =================================================
                    JOINED ON
                ================================================= */}

                <div className="account-item">

                    <Calendar size={22} />

                    <div>

                        <span>

                            Joined On

                        </span>


                        <h4>

                            {

                                user?.createdAt

                                    ?

                                    new Date(
                                        user.createdAt
                                    ).toLocaleDateString(
                                        "en-IN",
                                        {
                                            day: "2-digit",
                                            month: "long",
                                            year: "numeric"
                                        }
                                    )

                                    :

                                    "-"

                            }

                        </h4>

                    </div>

                </div>


                {/* =================================================
                    MEMBERSHIP / SERVICE
                ================================================= */}

                <div className="account-item">

                    <ShieldCheck size={22} />

                    <div>

                        <span>

                            Membership

                        </span>


                        <h4>

                            {
                                service
                            }

                        </h4>

                    </div>

                </div>


                {/* =================================================
                    ACCOUNT STATUS
                ================================================= */}

                <div className="account-item">

                    <ShieldCheck size={22} />

                    <div>

                        <span>

                            Account Status

                        </span>


                        <h4 className="active-status">

                            Active

                        </h4>

                    </div>

                </div>


            </div>

        </div>

    );

};


export default AccountInformation;